var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row profiel-page" }, [
    _c("div", { staticClass: "col-12 col-md-8" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _vm.loading
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v("\n          Loading...\n        ")
              ])
            : _c("div", [
                _c(
                  "form",
                  { on: { submit: _vm.handleSubmit } },
                  [
                    _vm.error
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-danger",
                            attrs: { role: "alert" }
                          },
                          [
                            _vm._v(
                              "\n              Helaas is er wat verkeerds gegaan, controleer en probeer opnieuw.\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.success
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-success",
                            attrs: { role: "alert" }
                          },
                          [
                            _vm._v(
                              "\n              Profiel is bijgewerkt.\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("file-field", {
                      attrs: {
                        error: _vm.avatar.error,
                        label: "Profiel foto",
                        name: "avatar",
                        multiple: false
                      },
                      model: {
                        value: _vm.avatar.value,
                        callback: function($$v) {
                          _vm.$set(_vm.avatar, "value", $$v)
                        },
                        expression: "avatar.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("input-field", {
                      attrs: {
                        error: _vm.name.error,
                        type: "text",
                        label: "Naam",
                        name: "name"
                      },
                      model: {
                        value: _vm.name.value,
                        callback: function($$v) {
                          _vm.$set(_vm.name, "value", $$v)
                        },
                        expression: "name.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("input-field", {
                      attrs: {
                        error: _vm.professional_headline.error,
                        type: "text",
                        label: "Professionele headline",
                        name: "professional_headline",
                        count: true,
                        max: 60
                      },
                      model: {
                        value: _vm.professional_headline.value,
                        callback: function($$v) {
                          _vm.$set(_vm.professional_headline, "value", $$v)
                        },
                        expression: "professional_headline.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("text-field", {
                      attrs: {
                        error: _vm.content.error,
                        label: "Beschrijving",
                        name: "description",
                        rows: "15",
                        count: true,
                        max: 2250
                      },
                      model: {
                        value: _vm.content.value,
                        callback: function($$v) {
                          _vm.$set(_vm.content, "value", $$v)
                        },
                        expression: "content.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("input-field", {
                      attrs: {
                        error: _vm.youtube.error,
                        type: "text",
                        label: "YouTube video toevoegen",
                        name: "youtube",
                        placeholder: "Plaats hier een YouTube video ID"
                      },
                      model: {
                        value: _vm.youtube.value,
                        callback: function($$v) {
                          _vm.$set(_vm.youtube, "value", $$v)
                        },
                        expression: "youtube.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("select-field", {
                      attrs: {
                        error: _vm.topic.error,
                        label: "Vakgebied",
                        name: "topic",
                        options: _vm.option_topics,
                        taggable: false
                      },
                      model: {
                        value: _vm.topic.value,
                        callback: function($$v) {
                          _vm.$set(_vm.topic, "value", $$v)
                        },
                        expression: "topic.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("multi-checkbox-field", {
                      attrs: {
                        error: _vm.software.error,
                        label: "Software",
                        name: "software",
                        options: _vm.option_softwares
                      },
                      model: {
                        value: _vm.software.value,
                        callback: function($$v) {
                          _vm.$set(_vm.software, "value", $$v)
                        },
                        expression: "software.value"
                      }
                    }),
                    _vm._v(" "),
                    _c("multi-checkbox-field", {
                      attrs: {
                        error: _vm.language.error,
                        label: "Talen",
                        name: "language",
                        options: _vm.option_language
                      },
                      model: {
                        value: _vm.language.value,
                        callback: function($$v) {
                          _vm.$set(_vm.language, "value", $$v)
                        },
                        expression: "language.value"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-lg",
                        attrs: { type: "submit" }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 15 15",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M1.95833 14.625H13.0417C13.4616 14.625 13.8643 14.4582 14.1613 14.1613C14.4582 13.8643 14.625 13.4616 14.625 13.0417V4.33333L10.6667 0.375H1.95833C1.53841 0.375 1.13568 0.541815 0.838748 0.838748C0.541815 1.13568 0.375 1.53841 0.375 1.95833V13.0417C0.375 13.4616 0.541815 13.8643 0.838748 14.1613C1.13568 14.4582 1.53841 14.625 1.95833 14.625ZM3.54167 1.95833H6.70833V3.54167H8.29167V1.95833H9.875V5.125H3.54167V1.95833ZM3.54167 8.29167H11.4583V13.0417H3.54167V8.29167Z"
                              }
                            })
                          ]
                        ),
                        _vm._v("\n              Opslaan\n            ")
                      ]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Profiel.vue?vue&type=template&id=d469d35a&
// module id = 434
// module chunks = 0